import React, { useEffect, useState, createElement, Component } from 'react';
import { CTAButton } from './components/CTAButton';
import { PurchasePopup } from './components/PurchasePopup';
import { CountdownBar } from './components/CountdownBar';
import { CheckCircle2, XCircle, ChevronDown, Star, Shield, Clock, Target, Zap, Users, BookOpen, Video, Award } from 'lucide-react';
export function App() {
  // Upsells state management
  const [upsell1Selected, setUpsell1Selected] = useState(false);
  const [upsell2Selected, setUpsell2Selected] = useState(false);
  // Calculate total price based on selections
  const calculateTotalPrice = () => {
    let total = 97990; // Base price
    if (upsell1Selected) total += 14990;
    if (upsell2Selected) total += 24990;
    return total;
  };
  // Get checkout URL based on selections
  const getCheckoutUrl = () => {
    if (upsell1Selected && upsell2Selected) {
      return 'https://8xz114-uy.myshopify.com/cart/51915023515879:1?channel=buy_button';
    } else if (upsell1Selected) {
      return 'https://8xz114-uy.myshopify.com/cart/51915013980391:1?channel=buy_button';
    } else if (upsell2Selected) {
      return 'https://8xz114-uy.myshopify.com/cart/51915077615847:1?channel=buy_button';
    } else {
      return 'https://8xz114-uy.myshopify.com/cart/51914995695847:1?channel=buy_button';
    }
  };
  // Inject Meta Pixel
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1330155108219675');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1330155108219675&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
  }, []);
  const scrollToCompra = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-white font-sans text-gray-800 selection:bg-yellow-200" data-id="element-0">
      <CountdownBar data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      {/* BLOQUE 1 — HERO */}
      <header className="bg-blue-900 text-white pt-14 pb-20 px-4 relative overflow-hidden" data-id="element-3">
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-4"></div>
        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-5">
          <div className="inline-block bg-yellow-500 text-black font-bold px-4 py-1 rounded-full text-sm mb-6 uppercase tracking-wider" data-id="element-6">
            UNICO EN TODA LA ARGENTINA
          </div>
          <h1 className="md:text-6xl font-extrabold mb-6 text-[26px]" data-id="element-7">
            Implementá en <span className="text-yellow-400" data-id="element-8">30 días</span> un
            sistema de marketing jurídico con IA para generar mas de{' '}
            <span className="text-yellow-400" data-id="element-9">100 consultas calificadas</span>{' '}
            al mes y crear el contenido de todo un mes en menos de{' '}
            <span className="text-yellow-400" data-id="element-10">48 horas</span>.
          </h1>

          <div className="mb-3" data-id="element-11">
            <a href="#compra" onClick={scrollToCompra} className="block cursor-pointer" data-id="element-12">
              <img src="https://cdn.magicpatterns.com/uploads/57Bfua9SgcXZYP3mnTZajS/1.png" alt="Marketing Jurídico 360 con IA" className="w-full h-auto" data-id="element-13" />
            </a>
          </div>

          <div className="max-w-3xl mx-auto mb-6" data-id="element-14">
            <p className="text-xl md:text-2xl text-blue-100 font-medium leading-relaxed" data-id="element-15">
              El sistema para que abogados generen{' '}
              <span className="text-yellow-400 font-bold" data-id="element-16">más consultas</span> y
              conviertan sus{' '}
              <span className="text-yellow-400 font-bold" data-id="element-17">redes sociales</span>{' '}
              en{' '}
              <span className="text-yellow-400 font-bold" data-id="element-18">
                oportunidades reales
              </span>
              , de forma ética y profesional.
            </p>
          </div>

          <div className="bg-blue-800/50 border border-blue-700 rounded-xl p-6 max-w-2xl mx-auto mb-8 backdrop-blur-sm" data-id="element-19">
            <p className="text-lg font-semibold mb-2" data-id="element-20">
              Curso grabado + 4 mentorías grupales en vivo + bonos + acceso de
              por vida.
            </p>
            <p className="text-3xl font-extrabold text-yellow-400 mb-6" data-id="element-21">
              Preventa Exclusiva SOLO 20 LUGARES
            </p>
            <CTAButton data-id="element-22" />
            <p className="mt-4 text-sm text-blue-200" data-id="element-23">
              Ideal para abogados argentinos independientes, recién matriculados
              o con poca experiencia en marketing y redes sociales.
            </p>
          </div>
        </div>
      </header>

      {/* BLOQUE 2 — PROBLEMA */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-24">
        <div className="max-w-4xl mx-auto" data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-12" data-id="element-26">
            Si sos abogado y hoy no sabés cómo conseguir más clientes desde
            redes, esto es para vos
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-27">
            <p data-id="element-28">
              Muchos abogados saben que deberían estar en redes, pero no saben
              qué publicar, cómo mostrarse, cómo usar inteligencia artificial ni
              cómo hacer anuncios sin perder plata.
            </p>

            <p className="font-semibold text-gray-900" data-id="element-29">
              Entonces pasa siempre lo mismo:
            </p>

            <div className="bg-white p-6 md:p-8 rounded-xl shadow-md border-l-4 border-red-500" data-id="element-30">
              <p className="italic" data-id="element-31">
                Publican sin estrategia. Se quedan sin ideas. No entienden Meta
                Ads. No convierten consultas en clientes. Y siguen dependiendo
                casi por completo del boca en boca.
              </p>
            </div>

            <p className="font-bold text-2xl text-blue-900 pt-6" data-id="element-32">
              El problema no es que no seas buen abogado.
            </p>
            <p data-id="element-33">
              El problema es que nadie te enseñó a usar redes, contenido,
              anuncios e IA como un sistema real de captación.
            </p>
          </div>

          <div className="mt-12 text-center" data-id="element-34">
            <CTAButton data-id="element-35" />
          </div>
        </div>
      </section>

      {/* BLOQUE 3 — PROPUESTA */}
      <section className="py-16 px-4 bg-white" data-id="element-36">
        <div className="max-w-4xl mx-auto" data-id="element-37">
          <h2 className="text-3xl md:text-5xl font-extrabold text-center text-blue-900 mb-10" data-id="element-38">
            Qué es Marketing Jurídico 360 con IA
          </h2>

          <p className="text-xl text-center mb-10 text-gray-700" data-id="element-39">
            Es un programa práctico para abogados argentinos que quieren usar
            redes sociales, Meta Ads e inteligencia artificial para:
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-40">
            {['Posicionarse mejor', 'Crear contenido más rápido', 'Atraer consultas calificadas', 'Convertir esas consultas en oportunidades reales'].map((item, i) => <div key={i} className="flex items-center gap-4 bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-41">
                <Target className="w-8 h-8 text-blue-600 flex-shrink-0" data-id="element-42" />
                <span className="text-lg font-semibold text-blue-900" data-id="element-43">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="text-center bg-gray-900 text-white p-8 rounded-2xl shadow-xl" data-id="element-44">
            <p className="text-xl mb-2" data-id="element-45">
              No es un curso para subir posteos por subir.
            </p>
            <p className="text-2xl font-bold text-yellow-400" data-id="element-46">
              Es un sistema para que tu marketing empiece a trabajar a favor de
              tu estudio o marca personal.
            </p>
          </div>
        </div>
      </section>

      {/* BLOQUE 4 — QUÉ VAS A LOGRAR */}
      <section className="py-16 px-4 bg-gray-50 border-y border-gray-200" data-id="element-47">
        <div className="max-w-4xl mx-auto" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-12" data-id="element-49">
            Al terminar el programa vas a poder
          </h2>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-50">
            {['Definir mejor qué comunicar y a quién', 'Optimizar tu perfil profesional', 'Crear contenido con IA sin perder criterio profesional', 'Organizar un calendario simple de publicaciones', 'Lanzar campañas básicas en Meta Ads', 'Atraer consultas con mayor intención', 'Responder mejor los mensajes', 'Hacer seguimiento sin improvisar', 'Dejar de depender solo de referidos'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-51">
                <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-52" />
                <span className="text-lg text-gray-700" data-id="element-53">{item}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* BLOQUE 5 — PARA QUIÉN ES */}
      <section className="py-16 px-4 bg-white" data-id="element-54">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-55">
          {/* Para quién sí */}
          <div className="bg-green-50 rounded-2xl p-8 border border-green-100 shadow-lg" data-id="element-56">
            <h3 className="text-2xl font-bold text-green-800 mb-6 flex items-center gap-2" data-id="element-57">
              <CheckCircle2 className="w-8 h-8" data-id="element-58" /> Este programa es para vos si
            </h3>
            <ul className="space-y-4" data-id="element-59">
              {['Sos abogado independiente', 'Recién te matriculaste o estás empezando', 'No tenés experiencia en marketing digital', 'No sabés qué publicar en redes', 'Querés generar más consultas y más clientes', 'Buscás una guía clara, profesional y paso a paso'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-60">
                  <CheckCircle2 className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-61" />
                  <span className="text-gray-800 font-medium" data-id="element-62">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Para quién no */}
          <div className="bg-red-50 rounded-2xl p-8 border border-red-100 shadow-lg" data-id="element-63">
            <h3 className="text-2xl font-bold text-red-800 mb-6 flex items-center gap-2" data-id="element-64">
              <XCircle className="w-8 h-8" data-id="element-65" /> No es para vos si
            </h3>
            <ul className="space-y-4" data-id="element-66">
              {['Buscás resultados mágicos sin aplicar nada', 'No querés exponerte ni comunicar tu trabajo', 'Querés hacer marketing agresivo o poco serio', 'Solo querés mirar clases sin implementar'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-67">
                  <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-68" />
                  <span className="text-gray-800 font-medium" data-id="element-69">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* BLOQUE 6 — QUÉ INCLUYE */}
      <section className="py-16 px-4 bg-blue-900 text-white" data-id="element-70">
        <div className="max-w-4xl mx-auto" data-id="element-71">
          <h2 className="text-3xl md:text-5xl font-extrabold text-center mb-16" data-id="element-72">
            Esto incluye Marketing Jurídico 360 con IA
          </h2>

          <div className="space-y-6" data-id="element-73">
            {[{
            mod: 'Módulo 0',
            title: 'Hoja de ruta de 30 días',
            desc: 'Qué vas a implementar, en qué orden y cómo medir avance.'
          }, {
            mod: 'Módulo 1',
            title: 'Posicionamiento jurídico que atrae consultas',
            desc: 'Nicho, cliente ideal, propuesta de valor, perfil de Instagram y WhatsApp profesional.'
          }, {
            mod: 'Módulo 2',
            title: 'Redes sociales para abogados',
            desc: 'Qué publicar, cómo generar autoridad, cómo usar reels, carruseles, historias y llamados a la acción.'
          }, {
            mod: 'Módulo 3',
            title: 'IA aplicada a contenido jurídico',
            desc: 'Prompts, ChatGPT, GPTs, ideas de contenido, guiones, copies, imágenes y videos.'
          }, {
            mod: 'Módulo 4',
            title: 'Meta Ads para atraer consultas calificadas',
            desc: 'Cómo crear campañas simples, anuncios, segmentación, mensajes y lectura básica de resultados.'
          }, {
            mod: 'Módulo 5',
            title: 'Conversión de consultas en clientes',
            desc: 'Cómo responder, filtrar, ordenar prospectos y hacer seguimiento.'
          }, {
            mod: 'Módulo 6',
            title: 'Optimización y crecimiento',
            desc: 'Cómo mejorar resultados, ordenar métricas y sostener el sistema.'
          }].map((m, i) => <div key={i} className="bg-blue-800/50 border border-blue-700 p-6 rounded-xl flex flex-col md:flex-row gap-4 items-start md:items-center" data-id="element-74">
                <div className="bg-yellow-500 text-blue-900 font-bold px-4 py-2 rounded-lg whitespace-nowrap" data-id="element-75">
                  {m.mod}
                </div>
                <div data-id="element-76">
                  <h4 className="text-xl font-bold mb-1" data-id="element-77">{m.title}</h4>
                  <p className="text-blue-200" data-id="element-78">{m.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* BLOQUE 7 — MENTORÍAS EN VIVO */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-79">
        <div className="max-w-4xl mx-auto text-center" data-id="element-80">
          <Video className="w-16 h-16 text-blue-600 mx-auto mb-6" data-id="element-81" />
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-82">
            Además vas a tener 4 mentorías grupales en vivo
          </h2>
          <p className="text-xl text-gray-600 mb-12" data-id="element-83">
            Una por semana durante 4 semanas para acompañarte en la
            implementación.
          </p>

          <div className="grid md:grid-cols-4 gap-4" data-id="element-84">
            {[{
            s: 'Semana 1',
            t: 'Posicionamiento, oferta y perfil'
          }, {
            s: 'Semana 2',
            t: 'Contenido, calendario y uso de IA'
          }, {
            s: 'Semana 3',
            t: 'Campañas y anuncios en Meta'
          }, {
            s: 'Semana 4',
            t: 'Respuestas, seguimiento y optimización'
          }].map((w, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-85">
                <div className="text-blue-600 font-bold mb-2" data-id="element-86">{w.s}</div>
                <div className="text-gray-800 font-medium" data-id="element-87">{w.t}</div>
              </div>)}
          </div>
        </div>
      </section>

      {/* BLOQUE 8 — BONOS */}
      <section className="py-16 px-4 bg-white" data-id="element-88">
        <div className="max-w-5xl mx-auto" data-id="element-89">
          <h2 className="text-3xl md:text-5xl font-extrabold text-center text-blue-900 mb-4" data-id="element-90">
            Si entrás en esta preventa, también te llevás estos 5 bonos
          </h2>
          <p className="text-center text-xl text-red-600 font-bold mb-16 uppercase tracking-wide" data-id="element-91">
            Gratis por el día de hoy
          </p>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-92">
            {/* Bono 1 */}
            <div className="bg-gray-50 rounded-2xl overflow-hidden border border-gray-200 shadow-lg group" data-id="element-93">
              <a href="#compra" onClick={scrollToCompra} className="block relative" data-id="element-94">
                <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-4 py-1 rounded-full z-10 shadow-md transform rotate-3" data-id="element-95">
                  GRATIS HOY
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/vNp96dfePiaKsSPvpefJmL/2.png" alt="Bono 1" className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-96" />
              </a>
              <div className="p-8" data-id="element-97">
                <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-98">
                  Bono 1. Biblioteca de prompts para abogados
                </h3>
                <p className="text-gray-600" data-id="element-99">
                  Prompts para ideas de contenido, reels, carruseles, anuncios,
                  copies y respuestas.
                </p>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="bg-gray-50 rounded-2xl overflow-hidden border border-gray-200 shadow-lg group" data-id="element-100">
              <a href="#compra" onClick={scrollToCompra} className="block relative" data-id="element-101">
                <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-4 py-1 rounded-full z-10 shadow-md transform rotate-3" data-id="element-102">
                  GRATIS HOY
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/j1fC9QwQby1dP1tW3hPrZz/3.png" alt="Bono 2" className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-103" />
              </a>
              <div className="p-8" data-id="element-104">
                <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-105">
                  Bono 2. Pack de GPTs y flujo IA
                </h3>
                <p className="text-gray-600" data-id="element-106">
                  GPTs sugeridos y sistema simple para producir contenido
                  semanal.
                </p>
              </div>
            </div>

            {/* Bono 3 */}
            <div className="bg-gray-50 rounded-2xl overflow-hidden border border-gray-200 shadow-lg group" data-id="element-107">
              <a href="#compra" onClick={scrollToCompra} className="block relative" data-id="element-108">
                <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-4 py-1 rounded-full z-10 shadow-md transform rotate-3" data-id="element-109">
                  GRATIS HOY
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/1KsDi2GPqgy9ZELUy5zjxD/4.png" alt="Bono 3" className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-110" />
              </a>
              <div className="p-8" data-id="element-111">
                <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-112">
                  Bono 3. Kit visual IA
                </h3>
                <p className="text-gray-600" data-id="element-113">
                  Prompts para imágenes, piezas visuales y videos cortos con
                  estética profesional.
                </p>
              </div>
            </div>

            {/* Bono 4 */}
            <div className="bg-gray-50 rounded-2xl overflow-hidden border border-gray-200 shadow-lg group" data-id="element-114">
              <a href="#compra" onClick={scrollToCompra} className="block relative" data-id="element-115">
                <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-4 py-1 rounded-full z-10 shadow-md transform rotate-3" data-id="element-116">
                  GRATIS HOY
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/vgv3VkgZpJ6vaew6ffgzKW/5.png" alt="Bono 4" className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-117" />
              </a>
              <div className="p-8" data-id="element-118">
                <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-119">
                  Bono 4. Pack Conversión Legal
                </h3>
                <p className="text-gray-600" data-id="element-120">
                  Scripts de WhatsApp, filtro de prospectos, formulario de
                  pre-calificación y CRM simple.
                </p>
              </div>
            </div>

            {/* Bono 5 */}
            <div className="bg-gray-50 rounded-2xl overflow-hidden border border-gray-200 shadow-lg group md:col-span-2" data-id="element-121">
              <a href="#compra" onClick={scrollToCompra} className="block relative" data-id="element-122">
                <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-4 py-1 rounded-full z-10 shadow-md transform rotate-3" data-id="element-123">
                  GRATIS HOY
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/fL6s1PVAGktEQQC4qK4KrJ/6.png" alt="Bono 5" className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-124" />
              </a>
              <div className="p-8" data-id="element-125">
                <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-126">
                  Bono 5. Comunidad Privada de WhatsApp
                </h3>
                <p className="text-gray-600" data-id="element-127">
                  Acceso a la comunidad de WhatsApp para resolver dudas, recibir
                  ayuda personalizada, clases, herramientas, actualizaciones
                  para tu crecimiento diario.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-16 text-center" data-id="element-128">
            <CTAButton data-id="element-129" />
          </div>
        </div>
      </section>

      {/* BLOQUE 9 — LO QUE TE LLEVÁS */}
      <section className="py-12 px-4 bg-blue-50 border-y border-blue-100" data-id="element-130">
        <div className="max-w-3xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-blue-100" data-id="element-131">
          <h2 className="text-3xl font-bold text-center text-blue-900 mb-8" data-id="element-132">
            En resumen, al entrar recibís
          </h2>
          <ul className="space-y-4 text-lg md:text-xl font-medium text-gray-800" data-id="element-133">
            {['Curso grabado completo', '6 módulos + hoja de ruta', '4 mentorías grupales en vivo', '5 bonos de implementación', 'Acceso de por vida (Solo los que accedan a la preventa)', 'Actualización de esta edición inicial'].map((item, i) => <li key={i} className="flex items-center gap-4 border-b border-gray-100 pb-4 last:border-0 last:pb-0" data-id="element-134">
                <CheckCircle2 className="w-8 h-8 text-yellow-500 flex-shrink-0" data-id="element-135" />
                <span data-id="element-136">{item}</span>
              </li>)}
          </ul>
        </div>
      </section>

      {/* BLOQUE 10 — AUTORIDAD */}
      <section className="py-16 px-4 bg-white" data-id="element-137">
        <div className="max-w-4xl mx-auto text-center" data-id="element-138">
          <Award className="w-16 h-16 text-blue-900 mx-auto mb-6" data-id="element-139" />
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-8" data-id="element-140">
            Este programa nace desde experiencia real en el nicho jurídico
          </h2>
          <div className="space-y-6 text-lg md:text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-141">
            <p data-id="element-142">No está armado desde teoría vacía.</p>
            <p data-id="element-143">
              Fue creado a partir de experiencia concreta trabajando con
              abogados, desarrollando contenido y llevando una cuenta de
              Instagram desde 0 hasta más de 30.000 seguidores.
            </p>
            <p className="font-semibold text-gray-900" data-id="element-144">
              La idea no es enseñarte marketing genérico.
            </p>
            <p data-id="element-145">
              La idea es mostrarte un sistema aplicable para abogados que
              quieren más visibilidad, más consultas y más oportunidades reales.
            </p>
          </div>
        </div>
      </section>

      {/* RESULTADOS REALES CAROUSEL */}
      <section className="py-16 px-4 bg-gradient-to-br from-blue-900 to-blue-800 text-white overflow-hidden" data-id="element-146">
        <div className="max-w-6xl mx-auto" data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-148">
            Resultados Reales de Marcas que Aplicaron el Sistema
          </h2>
          <p className="text-center text-blue-200 mb-12 text-lg" data-id="element-149">
            Crecimiento real en seguidores, engagement y conversiones
          </p>

          <ResultsCarousel data-id="element-150" />
        </div>
      </section>

      {/* TESTIMONIOS (Agregados según requerimiento) */}
      <section className="py-16 px-4 bg-gray-50 border-t border-gray-200" data-id="element-151">
        <div className="max-w-5xl mx-auto" data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-12" data-id="element-153">
            Lo que dicen abogados que ya aplican estos sistemas
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-154">
            {[{
            name: 'Martín L.',
            age: '34 años',
            city: 'Buenos Aires',
            spec: 'Derecho Laboral',
            text: 'Pasé de depender 100% del boca a boca a tener 3-5 consultas semanales por Instagram. El módulo de IA me ahorra horas de redacción.'
          }, {
            name: 'Carolina R.',
            age: '29 años',
            city: 'Córdoba',
            spec: 'Familia',
            text: 'Recién matriculada y perdida. Este curso me dio el paso a paso exacto. Ya cerré mis primeros dos clientes gracias a una campaña de Meta Ads que armé en 20 minutos.'
          }, {
            name: 'Javier G.',
            age: '42 años',
            city: 'Rosario',
            spec: 'Penal',
            text: "Pensé que las redes no eran para mi especialidad. Entendí cómo posicionarme con autoridad sin parecer un 'influencer'. Muy profesional todo el enfoque."
          }, {
            name: 'Sofía M.',
            age: '31 años',
            city: 'Mendoza',
            spec: 'Sucesiones',
            text: 'Lo que más me sirvió fue el pack de prompts. Antes tardaba 2 horas en pensar un posteo, ahora en 15 minutos tengo el calendario de toda la semana.'
          }, {
            name: 'Diego F.',
            age: '38 años',
            city: 'La Plata',
            spec: 'Derecho Comercial',
            text: 'El sistema de pre-calificación por WhatsApp vale 10 veces lo que cuesta el curso. Dejé de perder tiempo con consultas que no llegan a nada.'
          }].map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-155">
                <div className="flex text-yellow-400 mb-4" data-id="element-156">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-157" />)}
                </div>
                <p className="text-gray-700 italic mb-6" data-id="element-158">"{t.text}"</p>
                <div className="flex items-center gap-3" data-id="element-159">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-900 font-bold" data-id="element-160">
                    {t.name.charAt(0)}
                  </div>
                  <div data-id="element-161">
                    <p className="font-bold text-gray-900 text-sm" data-id="element-162">
                      {t.name}, {t.age}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-163">
                      {t.city} - {t.spec}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="mt-16 text-center" data-id="element-164">
            <CTAButton text="SÍ, QUIERO ESTOS RESULTADOS EN MI ESTUDIO" data-id="element-165" />
          </div>
        </div>
      </section>

      {/* BLOQUE 11 — PRECIO (SECCIÓN DE COMPRA) */}
      <section id="compra" className="py-24 px-4 bg-blue-900 text-white relative" data-id="element-166">
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-167">
          <div className="inline-block bg-yellow-500 text-black font-bold px-6 py-2 rounded-full text-sm mb-8 uppercase tracking-wider animate-pulse" data-id="element-168">
            Preventa Fundadora Abierta
          </div>

          <h2 className="text-4xl md:text-5xl font-extrabold mb-8" data-id="element-169">
            Hoy podés entrar a Marketing Jurídico 360 con IA por:
          </h2>

          <div className="bg-white text-blue-900 rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto transform transition-transform hover:scale-105 duration-300" data-id="element-170">
            <p className="text-gray-500 font-bold uppercase tracking-widest mb-2" data-id="element-171">
              Pago Único
            </p>
            <div className="text-6xl md:text-7xl font-black text-blue-900 mb-6 tracking-tighter" data-id="element-172">
              ARS {calculateTotalPrice().toLocaleString('es-AR')}
            </div>
            <p className="text-xl text-gray-600 mb-8 font-medium" data-id="element-173">
              Incluye todo lo que viste en esta página.
            </p>

            <div className="bg-red-50 text-red-700 p-4 rounded-lg mb-8 font-semibold border border-red-100" data-id="element-174">
              Este valor corresponde a la primera edición y luego va a aumentar.
            </div>

            {/* Upsells Section */}
            <div className="mb-8 border-t border-gray-200 pt-8" data-id="element-175">
              <h3 className="text-2xl font-bold text-blue-900 mb-2 text-center" data-id="element-176">
                Sumá estos extras opcionales a tu compra
              </h3>
              <p className="text-sm text-gray-600 mb-6 text-center" data-id="element-177">
                Potenciá tu implementación agregando herramientas
                complementarias con precio especial de lanzamiento.
              </p>

              <div className="space-y-4" data-id="element-178">
                {/* Upsell 1 */}
                <label className="flex items-start gap-4 p-4 border-2 border-gray-200 rounded-xl cursor-pointer hover:border-blue-300 hover:bg-blue-50/50 transition-all duration-200" data-id="element-179">
                  <input type="checkbox" checked={upsell1Selected} onChange={e => setUpsell1Selected(e.target.checked)} className="mt-1 w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer" data-id="element-180" />
                  <div className="flex-1" data-id="element-181">
                    <div className="flex items-center gap-2 mb-1" data-id="element-182">
                      <span className="text-xs font-bold text-yellow-600 bg-yellow-100 px-2 py-0.5 rounded-full uppercase tracking-wide" data-id="element-183">
                        Oferta especial
                      </span>
                    </div>
                    <h4 className="font-bold text-lg text-gray-900 mb-1" data-id="element-184">
                      Book de Fotos Profesionales con IA
                    </h4>
                    <p className="text-sm text-gray-600 mb-2" data-id="element-185">
                      Creación de book de fotos profesionales hechas con IA,
                      100% realistas con tu cara.
                    </p>
                    <p className="text-xl font-bold text-blue-600" data-id="element-186">
                      + ARS 14.990
                    </p>
                  </div>
                </label>

                {/* Upsell 2 */}
                <label className="flex items-start gap-4 p-4 border-2 border-gray-200 rounded-xl cursor-pointer hover:border-blue-300 hover:bg-blue-50/50 transition-all duration-200" data-id="element-187">
                  <input type="checkbox" checked={upsell2Selected} onChange={e => setUpsell2Selected(e.target.checked)} className="mt-1 w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer" data-id="element-188" />
                  <div className="flex-1" data-id="element-189">
                    <div className="flex items-center gap-2 mb-1" data-id="element-190">
                      <span className="text-xs font-bold text-blue-600 bg-blue-100 px-2 py-0.5 rounded-full uppercase tracking-wide" data-id="element-191">
                        Recomendado
                      </span>
                    </div>
                    <h4 className="font-bold text-lg text-gray-900 mb-1" data-id="element-192">
                      Tienda Online para Servicios Jurídicos + Mercado Pago
                    </h4>
                    <p className="text-sm text-gray-600 mb-2" data-id="element-193">
                      Aprendé a montar tu tienda online y vender tus servicios
                      vinculados a Mercado Pago a nivel nacional de forma
                      profesional.
                    </p>
                    <p className="text-xl font-bold text-blue-600" data-id="element-194">
                      + ARS 24.990
                    </p>
                  </div>
                </label>
              </div>
            </div>

            {/* Installment Payment Option */}
            <div className="mb-4 text-center" data-id="element-195">
              <p className="text-lg font-bold text-blue-900" data-id="element-196">
                En hasta 3 cuotas
              </p>
            </div>

            {/* Link de compra real */}
            <CTAButton text="QUIERO ACCEDER AHORA" className="w-full text-xl py-6" href={getCheckoutUrl()} data-id="element-197" />

            {/* Mercado Pago Security Badge */}
            <div className="mt-6 flex items-center justify-center gap-3 bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-198">
              <img src="https://cdn.magicpatterns.com/uploads/ht8czNhkAugiYoGqYay7Ew/mercadopago-81090.png" alt="Mercado Pago" className="w-12 h-12 object-contain" data-id="element-199" />
              <div className="text-left" data-id="element-200">
                <p className="text-sm font-bold text-blue-900 uppercase tracking-wide" data-id="element-201">
                  Pago 100% Asegurado por
                </p>
                <p className="text-lg font-extrabold text-blue-600" data-id="element-202">
                  MERCADO PAGO
                </p>
              </div>
            </div>

            <p className="mt-6 text-sm text-gray-500 font-bold flex items-center justify-center gap-2" data-id="element-203">
              <Clock className="w-4 h-4" data-id="element-204" /> Cupos limitados para esta edición de
              preventa.
            </p>
          </div>
        </div>
      </section>

      {/* GARANTÍA DE 7 DÍAS */}
      <section className="py-16 px-4 bg-gradient-to-br from-green-50 to-green-100" data-id="element-205">
        <div className="max-w-3xl mx-auto" data-id="element-206">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-2 border-green-500 relative animate-[neon-pulse_2s_ease-in-out_infinite]" style={{
          boxShadow: '0 0 20px rgba(34, 197, 94, 0.5), 0 0 40px rgba(34, 197, 94, 0.3), 0 0 60px rgba(34, 197, 94, 0.2), inset 0 0 20px rgba(34, 197, 94, 0.1)'
        }} data-id="element-207">
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-208">
              <Shield className="w-12 h-12 text-green-600" data-id="element-209" />
              <h2 className="text-3xl md:text-4xl font-extrabold text-green-900" data-id="element-210">
                Garantía de 7 Días
              </h2>
            </div>
            <p className="text-xl text-center text-gray-700 font-semibold mb-4" data-id="element-211">
              Devolución del 100% sin preguntas y sin vueltas de forma inmediata
            </p>
            <p className="text-center text-gray-600" data-id="element-212">
              Si por cualquier motivo no estás satisfecho con el programa, tenés
              7 días completos para solicitar la devolución total de tu
              inversión. Sin preguntas, sin complicaciones.
            </p>
          </div>
        </div>
      </section>

      {/* BLOQUE 12 — OBJECIONES */}
      <section className="py-16 px-4 bg-white" data-id="element-213">
        <div className="max-w-4xl mx-auto" data-id="element-214">
          <h2 className="md:text-4xl font-bold text-center text-blue-900 mb-12 text-[35px]" data-id="element-215">
            Capaz estás pensando esto
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-216">
            {[{
            q: 'No sé nada de marketing',
            a: 'Perfecto. El programa está pensado para abogados que arrancan desde cero.'
          }, {
            q: 'No sé usar inteligencia artificial',
            a: 'Está explicado de forma simple, práctica y aplicada al día a día.'
          }, {
            q: 'No tengo muchos seguidores',
            a: 'No necesitás una audiencia grande para empezar a ordenar tu sistema.'
          }, {
            q: 'Nunca hice anuncios',
            a: 'Hay un módulo específico para Meta Ads pensado para este perfil.'
          }, {
            q: 'No tengo tiempo',
            a: 'Justamente el objetivo es que uses IA y estructura para ahorrar tiempo y tener claridad.'
          }].map((obj, i) => <div key={i} className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-217">
                <h4 className="font-bold text-lg text-gray-900 mb-2" data-id="element-218">
                  "{obj.q}"
                </h4>
                <p className="text-gray-700" data-id="element-219">{obj.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* BLOQUE 13 — PREGUNTAS FRECUENTES */}
      <section className="py-16 px-4 bg-gray-50 border-t border-gray-200" data-id="element-220">
        <div className="max-w-3xl mx-auto" data-id="element-221">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-12" data-id="element-222">
            Preguntas frecuentes
          </h2>

          <div className="space-y-4" data-id="element-223">
            {[{
            q: '¿Es solo para abogados de Argentina?',
            a: 'Sí. Está orientado al mercado argentino.'
          }, {
            q: '¿Sirve si recién me matriculé?',
            a: 'Sí. Está especialmente pensado para abogados que están empezando o quieren independizarse.'
          }, {
            q: '¿Necesito saber de redes o marketing?',
            a: 'No. Se trabaja desde cero.'
          }, {
            q: '¿Voy a aprender Meta Ads?',
            a: 'Sí. Hay un módulo completo sobre campañas básicas para captar consultas.'
          }, {
            q: '¿Incluye clases en vivo?',
            a: 'Sí. Son 4 mentorías grupales, una por semana.'
          }, {
            q: '¿Cuánto tiempo tengo acceso?',
            a: '12 meses.'
          }, {
            q: '¿Tengo que mostrar mi cara?',
            a: 'No en todos los casos, pero sí vas a aprender a construir autoridad personal de forma progresiva.'
          }].map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-224" />)}
          </div>
        </div>
      </section>

      {/* BLOQUE 14 — CIERRE */}
      <section className="py-24 px-4 bg-blue-900 text-white text-center" data-id="element-225">
        <div className="max-w-4xl mx-auto" data-id="element-226">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-8 leading-tight" data-id="element-227">
            Tu conocimiento jurídico ya lo tenés. Ahora necesitás un sistema
            para que más personas lleguen a vos.
          </h2>

          <div className="text-xl md:text-2xl text-blue-200 space-y-6 mb-12 font-medium" data-id="element-228">
            <p data-id="element-229">
              Podés seguir improvisando. Podés seguir postergando redes,
              anuncios e inteligencia artificial.
            </p>
            <p className="text-white" data-id="element-230">
              O podés implementar un sistema claro, profesional y pensado para
              abogados.
            </p>
          </div>

          <p className="text-lg text-blue-100 mb-12 max-w-3xl mx-auto" data-id="element-231">
            Marketing Jurídico 360 con IA fue creado para ayudarte a ordenar tu
            presencia digital, generar más consultas calificadas y convertir tu
            marketing en una herramienta real de crecimiento.
          </p>

          <div className="bg-blue-800/50 p-8 rounded-2xl border border-blue-700 max-w-2xl mx-auto" data-id="element-232">
            <p className="font-bold text-yellow-400 mb-8 text-[28px]" data-id="element-233">
              Preventa fundadora: ARS 97.990
            </p>
            <CTAButton text="QUIERO ENTRAR A LA PREVENTA" className="w-full md:w-auto" data-id="element-234" />
          </div>
        </div>
      </section>
    </div>;
}
// Helper component for FAQ accordion
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white border border-gray-200 rounded-lg overflow-hidden transition-all duration-200" data-id="element-235">
      <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-236">
        <span className="font-bold text-gray-900 pr-4" data-id="element-237">{question}</span>
        <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-200 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-238" />
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-239">
        <p className="text-gray-700" data-id="element-240">{answer}</p>
      </div>
    </div>;
}
// Results Carousel Component
function ResultsCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const results = [{
    image: 'https://cdn.magicpatterns.com/uploads/nzVvaUuQSR6JdyHFS6oBFm/Diseno_sin_titulo.png',
    alt: 'Resultados Antes y Después - Estudiantes de Abogacía'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/52vDC82NFWpMeXRfggZupR/Captura_de_pantalla_2026-03-24_201035.png',
    alt: 'Métricas de Conversión y ROI'
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % results.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <div className="relative max-w-4xl mx-auto" data-id="element-241">
      <div className="relative aspect-square rounded-2xl overflow-hidden shadow-2xl" data-id="element-242">
        {results.map((result, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ${index === currentIndex ? 'opacity-100' : 'opacity-0'}`} data-id="element-243">
            <img src={result.image} alt={result.alt} className="w-full h-full object-contain bg-white" data-id="element-244" />
          </div>)}
      </div>

      {/* Carousel Indicators */}
      <div className="flex justify-center gap-2 mt-6" data-id="element-245">
        {results.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 rounded-full transition-all duration-300 ${index === currentIndex ? 'w-8 bg-yellow-400' : 'w-2 bg-blue-300 hover:bg-blue-200'}`} aria-label={`Ir a resultado ${index + 1}`} data-id="element-246" />)}
      </div>

      <div className="mt-8 text-center" data-id="element-247">
        <p className="text-blue-100 text-lg font-medium" data-id="element-248">
          Estos son resultados reales de marcas que implementaron Marketing
          Jurídico 360 con IA
        </p>
      </div>
    </div>;
}